<template>
  <div :class="columnClassName">
    <column-header :activeLayout="activeLayout" :columns="columns" :columnIndex="columnIndex" :components="components" :activeComponent="component" v-on:setActiveComponent="setActiveComponent"></column-header>
  </div>
</template>

<script>

import { mapGetters } from 'vuex'
import components from '~/lib/components'

export default {
  mixins: [components]
}

</script>